import Axios from 'axios';
import SearchIcon from '../../assets/icons/SearchIcon';
import TextInput from '../../components/textInput/TextInput';
import * as style from './style.css';
import React = require('react');

interface IProps {
    uriBuilder: (uir: string) => string;
}

interface IState {
    searchText

}

export default class SearchBar extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            searchText: ''
        };
    }

    axios = Axios;

    render() {
        return (
            <div className={style.searchBarWrapper}>
                <TextInput
                    value={this.state.searchText}
                    onChange={(s: string) => this.setState({ searchText: s })}
                    onKeyDown={(key) => this.onKeyDown(key)}
                    placeholder="Szukaj" >
                    <SearchIcon onClick={() => this.postSearch()} />
                </TextInput>

            </div>
        );
    }

    onKeyDown(key: string): void {
        if (key === 'Enter') { this.postSearch(); }
    }

    postSearch() {
        if (this.state.searchText.length >= 3) {
            const uri = this.props.uriBuilder('katalog?szukaj=' + this.state.searchText);
            window.location.href = uri;
        }
    }
}
